import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class SortDirectionLinkViewModel extends LinkViewModel {
    public direction: KnockoutObservable<'ASC'|'DESC'>;
    private readonly descending = '▼';
    private readonly ascending = '▲';
    private readonly toolTipErgNamePrefix = 'SORT_DIRECTION_'

    public constructor(protected params: any) {
        super($.extend({
            locator: 'button.change-sortDirection'
        }, params));

        this.direction = this.observableOrDefault(this.params.direction, 'ASC');
        this.tooltip = new LabelViewModel({ ergName: this.toolTipErgNamePrefix + this.direction() });
        this.label = new LabelViewModel({ caption: this.direction() == 'ASC' ? this.ascending : this.descending });
    }

    /**
     * @override 
     */
    public onClick(): void {
        this.direction() === 'ASC' ? this.direction('DESC') : this.direction('ASC');
        if (this.isDisposed) {
            return;
        }
        this.label.caption(this.direction() === 'ASC' ? this.ascending : this.descending);
        this.tooltip.ergName(this.toolTipErgNamePrefix + this.direction());
    }
}

ComponentManager.setViewModel('SortDirectionLink', SortDirectionLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');